import { render, staticRenderFns } from "./VRBusinessValue.vue?vue&type=template&id=52c9537f"
import script from "./VRBusinessValue.vue?vue&type=script&lang=js"
export * from "./VRBusinessValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports